import DeviceDetails from './DeviceDetails';

export default DeviceDetails;
